<script>
  export let btnName = "button"
  export let btnclr = "blue"
  export let active = true
</script>

<button on:click type="button" class="{btnclr} {active ? '!bg-blue-500 !text-white' : ''} rounded-full px-3 py-1 text-xs font-semibold text-white">{btnName}</button>

<style lang="postcss">
  .blue {
    @apply bg-blue-200  text-blue-600 hover:bg-blue-400 hover:text-white active:bg-blue-300;
  }
</style>
